import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { HttpService  } from '../../core/services/http/http.service';
import { Buyer } from '../../../store/actions/buyerActions';
@Injectable({
  providedIn: 'root'
})
export class BuyerService {
  constructor(private store: Store<any>,private http: HttpService) { }
  buyer(){
    return this.http.query('get', 'all-announcements?type=0&min=0&max=5', {});
  }
 
  dispatchBuyerAction()
  {
    this.store.dispatch(new Buyer());
  }
}